import { BenchmarkRunner } from "./BenchmarkRunner";
import type { BenchmarkConfig, BenchmarkResult } from "./PerformanceTiers";

export { BenchmarkRunner } from "./BenchmarkRunner";
export { GPUBenchmark } from "./GPUBenchmark";
export {
  type BenchmarkConfig,
  type BenchmarkResult,
  calculatePerformanceTier,
  DEFAULT_CONFIG,
  getScoreFromSubdiv,
  PerformanceTier,
  SUBDIV_SEQUENCE,
  TIER_THRESHOLDS,
} from "./PerformanceTiers";

// Main API function for easy usage
export async function runGPUBenchmark(
  config?: Partial<BenchmarkConfig>,
  onProgress?: (progress: number, currentSubdiv: number) => void,
  onFrameCapture?: (subdiv: number, imageData: ImageData, frameTime: number) => void
): Promise<BenchmarkResult> {
  const runner = new BenchmarkRunner(config, onProgress, onFrameCapture);
  return runner.run();
}
